export enum FormRequiredStatus {
  REQUIRED = 'Required',
  OPTIONAL = 'Optional',
  NOT_APPLICABLE = 'Not applicable',
}

export enum FormAvailabilityStatus {
  NOT_YET_AVAILABLE = 'Not yet available',
  AVAILABLE = 'Available',
  NOT_AVAILABLE = 'Not available',
}

export enum FormCompletionStatus {
  NEW = 'New',
  IN_PROGRESS = 'In progress',
  SUBMITTED = 'Submitted',
  PENDING = 'Pending approval',
  REJECTED = 'Rejected',
  DOWNLOADED = 'Downloaded',
}
